import styled, { css } from 'styled-components'

// Container for the entire debugger widget
export const Container = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  width: 400px;
  max-height: 80vh;
  background-color: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  font-family: monospace;
  font-size: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: default;
`

// Header with drag handle
export const Header = styled.div`
  padding: 8px 12px;
  background-color: #f0f0f0;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
`

export const Title = styled.h3`
  margin: 0;
  font-weight: bold;
`

export const CloseButton = styled.button`
  background: none;
  border-width: 0;
  cursor: pointer;
  font-size: 16px;
`

export const TabsContainer = styled.div`
  display: flex;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #ccc;
`

export const Tab = styled.button<{ $isActive?: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  background-color: #f8f8f8;
  border-width: 0;
  
  ${props => props.$isActive && css`
    background-color: #fff;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: #007bff;
  `}
`

export const Content = styled.div`
  padding: 12px;
  overflow-y: auto;
  flex-grow: 1;
`

export const SearchBox = styled.input`
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  border-radius: 4px;
`

export const StateTree = styled.div`
  margin: 0;
  padding: 0;
`

export const StateField = styled.div<{ $isExpanded?: boolean }>`
  margin: 2px 0;
  padding: 4px;
  border-radius: 2px;
  cursor: pointer;
  
  ${props => props.$isExpanded && css`
    background-color: #f0f8ff;
  `}
  
  &:hover {
    background-color: ${props => props.$isExpanded ? '#e6f2ff' : '#f5f5f5'};
  }
`

export const ExpandButton = styled.span`
  margin-right: 4px;
  cursor: pointer;
`

export const TreeContainer = styled.div<{ $indented?: boolean }>`
  margin-left: ${props => props.$indented ? '20px' : '0'};
`

export const Footer = styled.div`
  padding: 8px;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #ccc;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const FooterRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const FooterButton = styled.button<{ $isWarning?: boolean }>`
  padding: 4px 8px;
  background-color: #f0f0f0;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  border-radius: 4px;
  cursor: pointer;
  margin: 4px;
  
  ${props => props.$isWarning && css`
    color: red;
  `}
  
  &:hover {
    background-color: #e6e6e6;
  }
`

export const ErrorMessage = styled.div`
  color: red;
`
